import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import Guid from "_shared/guids/guid";
import AssistantCitationSchema, { AssistantCitationJSON, AssistantCitationParams } from "ai-assistant/citations/assistant-citation-schema";

export default class AssistantCitation {
  public static create(values: AssistantCitationParams): AssistantCitation {
    const parsed = AssistantCitationSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid AssistantCitation parameters.");
    }
    return new AssistantCitation(parsed);
  }
  
  public static fromJSON(json: AssistantCitationJSON): AssistantCitation {
    if (isNullOrUndefined(json)) return json;
    const params = AssistantCitationSchema.deserialize(json);
    return new AssistantCitation(params);
  }

  public readonly fileId: Guid; 
  public readonly fileName: string;
  public readonly page?: number;
  public readonly nodeId?: Guid;
  public readonly score?: number;
  public readonly semanticScore?: number;
  public readonly combinedScore?: number;
  public readonly matched?: boolean;
  public readonly text?: string;
  
  public constructor(params: AssistantCitationParams) {
    this.fileId = params.fileId;
    this.fileName = params.fileName;
    this.page = params.page;
    this.nodeId = params.nodeId;
    this.score = params.score;
    this.semanticScore = params.semanticScore;
    this.combinedScore = params.combinedScore;
    this.matched = params.matched;
    this.text = params.text;
  }

  public toJSON(): AssistantCitationJSON {
    return AssistantCitationSchema.serialize(this);
  }
  
  public toString(): string {
    return `
      File ID: ${this.fileId}, 
      File Name: ${this.fileName},
      Page: ${this.page},
      Node ID: ${this.nodeId},
      Score: ${this.score},
      Semantic Score: ${this.semanticScore},
      Combined Score: ${this.combinedScore},
      Matched: ${this.matched},
      Text: ${this.text}
    `;
  }
}
